var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide"},[_c('p',{staticClass:"gl-mb-7"},[_vm._v("\n    "+_vm._s(_vm.__(
        'Open the GitLab Duo AI assistant panel from anywhere in GitLab. Ask questions, request code help, or get guidance without interrupting your workflow.',
      ))+"\n  ")]),_vm._v(" "),_c('illustration')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }